import { TrendingUp, CalendarCheck, Ban, Crosshair } from "lucide-react";
import { Container, CountUp, Reveal } from "@/components/kit";

const metrics = [
  { icon: TrendingUp, prefix: "+", to: 340, suffix: "%", label: "Avg. pipeline growth", decimals: 0 },
  { icon: CalendarCheck, prefix: "", to: 42, suffix: "/mo", label: "Qualified meetings booked", decimals: 0 },
  { icon: Ban, prefix: "$", to: 0, suffix: "", label: "Charged for unqualified", decimals: 0 },
  { icon: Crosshair, prefix: "", to: 92, suffix: "%", label: "ICP targeting accuracy", decimals: 0 },
];

export const MetricsStrip = () => (
  <section data-testid="metrics-strip" className="py-16 md:py-20 border-b border-white/10">
    <Container>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
        {metrics.map((m, i) => (
          <Reveal
            key={m.label}
            delay={i * 0.08}
            className="relative text-center md:text-left"
          >
            <m.icon className="mx-auto md:mx-0 h-6 w-6 text-gold/70" />
            <p className="mt-4 font-mono-jb text-4xl md:text-5xl lg:text-6xl font-semibold text-gold text-glow-gold">
              <CountUp to={m.to} prefix={m.prefix} suffix={m.suffix} decimals={m.decimals} />
            </p>
            <p className="mt-2 text-sm text-white/55">{m.label}</p>
          </Reveal>
        ))}
      </div>
    </Container>
  </section>
);
